import CryptoJS from 'crypto-js';
import { API_BASE_URL } from '../remote/config';
import log from 'loglevel';

const APP_SECRET = process.env.REACT_APP_API_SECRET || '';

interface SignatureParams {
    method: string;
    uri: string;
    timestamp: number;
    nonce: string;
    body?: any;
}

export const generateSignature = ({method, uri, timestamp, nonce, body}: SignatureParams): string => {
    // 构建签名字符串，与后端保持一致
    const signString = `${method.toUpperCase()}${uri}${timestamp}${nonce}${body ? JSON.stringify(body) : ''}`;
    log.debug('signString:', signString);
    const signature = CryptoJS.HmacSHA256(signString, APP_SECRET).toString(CryptoJS.enc.Base64);
    return signature;
};

export const generateNonce = (): string => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = Date.now().toString(36).toUpperCase();
    // 补充剩余位数，确保总长度为32位
    while (result.length < 32) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
};